import "./index.css";
// import ContactUs from '../../components/ContactUs'

export default function Setores() {
  return (
    <div className="container">
      <div className="my-5">
        <header className="setores-header">
          <h1 className="my-5">Setores de Atuação - Clima Tropical</h1>
          <p>
            Oferecemos serviços especializados em manutenção, montagem e
            reparação de sistemas de ar condicionado para diversos ambientes e
            setores, garantindo conforto, eficiência e tecnologia de ponta.
          </p>
        </header>

        <div className="setores-content">

          {/* Setor: Residencial */}
          <div className="setor">
            <h2>Residencial</h2>
            <p>
              Instalamos e fazemos manutenção de sistemas de ar condicionado em
              residências, proporcionando conforto térmico e eficiência
              energética para o seu lar.
            </p>
          </div>

          {/* Setor: Comercial */}
          <div className="setor">
            <h2>Comercial e Escritórios</h2>
            <p>
              Nossos serviços para escritórios, lojas, e espaços comerciais
              garantem ambientes climatizados e saudáveis, melhorando a
              produtividade e o bem-estar.
            </p>
          </div>

          {/* Setor: Hospitais e Clínicas */}
          <div className="setor">
            <h2>Hospitais e Clínicas</h2>
            <p>
              Atuamos na climatização de hospitais, clínicas e centros de saúde,
              seguindo rigorosos padrões de qualidade e segurança para garantir
              ambientes limpos e seguros.
            </p>
          </div>

          {/* Setor: Veículos */}
          <div className="setor">
            <h2>Veículos</h2>
            <p>
              Realizamos a montagem e manutenção de sistemas de ar condicionado
              em veículos leves, pesados, e até mesmo aeronaves, proporcionando
              conforto em suas viagens.
            </p>
          </div>

          {/* Setor: Shoppings e Lojas */}
          <div className="setor">
            <h2>Shoppings e Lojas</h2>
            <p>
              Oferecemos soluções de climatização para grandes espaços como
              shoppings e lojas, garantindo conforto para clientes e
              funcionários.
            </p>
          </div>

          {/* Setor: Data Centers e Salas de Servidores */}
          <div className="setor">
            <h2>Data Centers e Salas de Servidores</h2>
            <p>
              Especializados em climatização para salas de servidores e data
              centers, asseguramos a temperatura ideal para o funcionamento de
              equipamentos críticos.
            </p>
          </div>

          {/* Setor: Indústria e Grandes Instalações */}
          <div className="setor">
            <h2>Indústria e Grandes Instalações</h2>
            <p>
              Prestamos serviços de manutenção e instalação de sistemas de ar
              condicionado em grandes indústrias e instalações, com foco em
              eficiência e sustentabilidade.
            </p>
          </div>
        </div>
      </div>

      {/* <ContactUs/> */}
    </div>
  );
}
